// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const CellPhone: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 59"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M35.6 3.3c-.1-1.7-1.5-3-3.1-3H3.6C1.9.3.5 1.7.5 3.4v52.4c0 1.7 1.4 3.1 3.1 3.1h28.9c1.7 0 3.1-1.4 3.1-3.1V3.3zM33 55.7c0 .3-.2.5-.5.5H3.6c-.3 0-.5-.2-.5-.5v-6.4h30v6.4zM3.1 46.8V12.9h30v33.9h-30zm0-36.4V3.3c0-.3.2-.5.5-.5h28.9c.3 0 .5.2.5.5v7.1H3.1z"/><circle cx="18.9" cy="53" r="2"/><path d="M21.5 5.7h-7c-.3 0-.5.3-.5.5V7c0 .3.2.5.5.5h7c.3 0 .5-.2.5-.5v-.8c0-.2-.2-.5-.5-.5z"/></svg>;
};

export default React.memo(CellPhone);
